import urlParse from 'url-parse';
import tinycolor2 from 'tinycolor2';

import ubBanzai from 'ub/control/banzai-features';

const pathContainsSvg = (path) => {
  const parsedUrl = urlParse(path, {});

  return /\.svg$/i.test(parsedUrl.pathname);
};

const readUploadedFileAsText = (file) => {
  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onerror = () => {
      reader.abort();
      reject(new DOMException("Problem parsing input file."));
    };

    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsText(file);
  });
};

const setClasses = (svg, type) => {
  const colors = {};
  svg.querySelectorAll(`[${type}]`).forEach(el => {
    const col = el.getAttribute(`${type}`);
    if (col === 'none') return;
    const colorString = tinycolor2(col).toRgbString();
    if (Array.isArray(colors[colorString])) {
      colors[colorString].push(el);
    } else {
      colors[colorString] = [el];
    }
  });

  let colorNum = 0;
  Object.keys(colors)
    .forEach((color) => {
      colors[color].forEach(el => el.classList.add(`color-${type}-${colorNum}`));
      colorNum++;
    });
};

const constructBlob = (svgString) => {
  return new Blob([svgString], { type: 'image/svg+xml' });
};

const addColorClasses = (asset) => {
  const blob = asset.slice();
  return readUploadedFileAsText(blob)
    .then((fileString) => {
      const svg = new window.DOMParser().parseFromString(fileString, "text/xml");
      setClasses(svg, 'fill');
      setClasses(svg, 'stroke');
      // svg back to string
      const svgString = new XMLSerializer().serializeToString(svg);
      // set string to file content
      const newBlob = constructBlob(svgString);
      const newFile = new File([newBlob], asset.name, {
        lastModified: asset.lastModified,
        type: 'image/svg+xml',
      });

      return newFile;
    });
};

const addColorClassesToSvgs = assets => {
  const colorsEnabled = ubBanzai.features.isSvgColorEnabled();
  return Promise.all(
    assets.map(asset =>
      colorsEnabled && asset.type === 'image/svg+xml' ? addColorClasses(asset) : asset
    )
  );
};

export default {
  pathContainsSvg,
  addColorClassesToSvgs,
  setClasses,
};



// WEBPACK FOOTER //
// ./src/ui/svg/svg-upload.js